import { makeApiRequest } from './api.service'
import { useNotefieIdStore } from './../stores/notefieID'
export interface NotefieIDs {
  label: string
  value: string
  siteLocation: string
}
export class NotefieIDsService {
  async getNotefieIDs() {
    const notefieIdStore = useNotefieIdStore()
    if (notefieIdStore.allNotefieIDs.length === 0) {
      try {
        const response = await makeApiRequest({
          path: '/mongodb',
          body: {
            getNotefieIDs: true
          }
        })
        if (response.success && response.data) {
          const data: any = response.data
          //store all user's ID to store
          const allNotefieIDsLocal = <Array<NotefieIDs>>[]
          if (data) {
            data.forEach((element: any) => {
              allNotefieIDsLocal.push({
                label: element.siteLocation + ' - ' + element.notefieID,
                value: element.notefieID,
                siteLocation: element.siteLocation
              })
            })
            //copy array to store
            notefieIdStore.allNotefieIDs = allNotefieIDsLocal
            //set first index as active
            const firstID = allNotefieIDsLocal[0]
            if (firstID) {
              notefieIdStore.notefieID = firstID.value
              notefieIdStore.siteLocation = firstID.siteLocation
              notefieIdStore.siteLocationNotefieID = firstID.label
            }
            return notefieIdStore.allNotefieIDs
          } else {
            notefieIdStore.allNotefieIDs = [] //clear any leftover data in storage
            return this.getDefaultEmpty()
          }
        }
        notefieIdStore.allNotefieIDs = []
        return this.getDefaultEmpty()
      } catch (error) {
        notefieIdStore.allNotefieIDs = []
        return this.getDefaultEmpty()
      }
    } else {
      return notefieIdStore.allNotefieIDs
    }
  }
  async overwriteNotefieIDs() {
    const notefieIdStore = useNotefieIdStore()
    try {
      const response = await makeApiRequest({
        path: '/mongodb',
        body: {
          getNotefieIDs: true
        }
      })
      if (response.success && response.data) {
        const data: any = response.data
        //store all user's ID to store
        const allNotefieIDsLocal = <Array<NotefieIDs>>[]
        if (data) {
          data.forEach((element: any) => {
            allNotefieIDsLocal.push({
              label: element.siteLocation + ' - ' + element.notefieID,
              value: element.notefieID,
              siteLocation: element.siteLocation
            })
          })
          //copy array to store
          notefieIdStore.allNotefieIDs = allNotefieIDsLocal
          //set first index as active
          const firstID = allNotefieIDsLocal[0]
          if (firstID) {
            notefieIdStore.notefieID = firstID.value
            notefieIdStore.siteLocation = firstID.siteLocation
            notefieIdStore.siteLocationNotefieID = firstID.label
          }
          return notefieIdStore.allNotefieIDs
        } else {
          notefieIdStore.allNotefieIDs = [] //clear any leftover data in storage
          return this.getDefaultEmpty()
        }
      }
      notefieIdStore.allNotefieIDs = []
      return this.getDefaultEmpty()
    } catch (error) {
      notefieIdStore.allNotefieIDs = []
      return this.getDefaultEmpty()
    }
  }
  private getDefaultEmpty() {
    return []
  }
}
export const notefieIDsService = new NotefieIDsService()
